'use client';

import React from 'react';
import {
  Drawer,
  DrawerHeader,
  DrawerBody,
  Portal
} from 'components/pcc-components';
import {
  CatButton,
  CatHeading,
  CatIconChevronRight
} from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import styles from './frequently-mobile-bought-together-drawer.module.scss';
import { ROOT_PORTALS } from 'constants/targets';
import { useFbtMobileDrawer } from './fbt-mobile-drawer-context';
export interface FBTMobileProps {
  children: React.ReactNode;
  fireGAEventForViewAllParts?: { (arg0: boolean): void };
}
export const FBTMobileDrawer = ({
  children,
  fireGAEventForViewAllParts
}: Readonly<FBTMobileProps>) => {
  const { drawerProps, openDrawer, closeDrawer, isDrawerOpen } =
    useFbtMobileDrawer();
  const t = useTranslations();

  const onViewAllPartsPress = () => {
    openDrawer();
    fireGAEventForViewAllParts && fireGAEventForViewAllParts(true);
  };
  return (
    <>
      <CatButton
        data-testid="cat-button"
        className="align-self-end"
        onClick={onViewAllPartsPress}
      >
        {t('VIEW_ALL_PARTS')}
        <CatIconChevronRight slot="after" />
      </CatButton>

      <Portal id={ROOT_PORTALS}>
        <Drawer
          className={styles['fbt-drawer__header']}
          data-testId="fbt-drawer"
          orientation="side"
          onBlDrawerClose={closeDrawer}
          hasBackdrop={false}
          isActive={isDrawerOpen}
          {...drawerProps}
        >
          <DrawerHeader>
            <CatHeading
              data-testId="fbt-heading"
              className="text-capitalize"
              variant="title-sm"
            >
              {t('FREQUENTLY_BOUGHT_TOGETHER')}
            </CatHeading>
          </DrawerHeader>
          <DrawerBody className={styles['fbt_body_container']}>
            {children}
          </DrawerBody>
          <div slot="footer">
            <div id="fbt-mobile-drawer-footer-container" />
          </div>
        </Drawer>
      </Portal>
    </>
  );
};
